import {
  addLoadingState as coreAddLoadingState,
  removeLoadingState as coreRemoveLoadingState,
} from '@sg-core/resources/assets/js/helpers/buttons';

import type { ComponentPublicInstance } from 'vue';

type ButtonTarget = HTMLElement | ComponentPublicInstance;

interface LoadingStateOptions {
  dark?: boolean;
  size?: string;
  text?: string;
  iconOnly?: boolean;
  type?: 'circle' | 'line';
}

export function addLoadingState(target: ButtonTarget, options: LoadingStateOptions = {}): void {
  coreAddLoadingState(target, {
    ...options,
    type: options.type ?? 'line',
  });
}

export const removeLoadingState = coreRemoveLoadingState;
